import React from 'react';
import SidebarUnitDesktop
    from "components/sidebar/components/SidebarUnitDesktop";
import {CogIcon} from "assets/icons";

const ProfilLink = () => {
    return (
        <SidebarUnitDesktop 
            routeName={"Paramètres"} 
            routeSidebar={"/profil/myAccountCompany"}
            icon={CogIcon}
            text={"Paramètres"}
        />
    );
};

export default ProfilLink;